import { createWebHistory, createRouter } from 'vue-router';
import { getUser } from "./auth.js"

const routes = [
    // ----------------------------------------------------------------
    // Dashboard
    // ----------------------------------------------------------------
    {
        path: "/",
        name: "dashboard",
        component: () => import("./Dashboard.vue"),
    },
    // ----------------------------------------------------------------
    // Login
    // ----------------------------------------------------------------
    {
        path: "/set_session",
        name: "set_session",
        component: () => import("./SetSession.vue"),
    },
    // ----------------------------------------------------------------
    // Generic landing
    // ----------------------------------------------------------------
    {
        path: "/genericlanding/list",
        name: "genericlanding.list",
        component: () => import("./genericlanding/GenericLandingList.vue")
    },
    {
        path: "/genericlanding/editor",
        name: "genericlanding.editor",
        component: () => import("./genericlanding/GenericLandingEditor.vue")
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (toRoute, fromRoute) => {
    console.log(`[router] Moving from ${fromRoute.path} to ${toRoute.path}`);
    if (toRoute.name === "set_session" && "c" in toRoute.query) {
        console.log("[router] Movement allowed to set session cookie");
        return true; // Set the session to authenticate
    }
    // Any other request is blocked if unauthenticated
    let user = await getUser();
    console.log(`Checking auth user`, user, `authenticated? `, user != null);
    if (user == null) {
        // Unauthenticated!
        const backendUrl = process.env.VUE_APP_WEBAPP_URL;
        const ticpUrl = process.env.VUE_APP_TICP_URL;
        const redirectTo = `${backendUrl}/set_session`;
        const url = new URL(`${ticpUrl}/login`);
        url.searchParams.set("redirect_to", redirectTo);
        window.location.replace(url.toString());
        return false;
    }
    return true;
});

export default router;
